import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const CUSTOMER_API_URL = `${BACKEND}/api`;

export const customerApi = axios.create({
    baseURL: CUSTOMER_API_URL,
});

export const setCustomerToken = (token) => {
    if (token) {
        customerApi.defaults.headers.common["X-Customer-Token"] = token;
        localStorage.setItem("st_customer_token", token);
    } else {
        delete customerApi.defaults.headers.common["X-Customer-Token"];
        localStorage.removeItem("st_customer_token");
    }
};

const stored = localStorage.getItem("st_customer_token");
if (stored) {
    customerApi.defaults.headers.common["X-Customer-Token"] = stored;
}
